import React from 'react';
import Config from '../../../Config';
import iIcon from './images/i-icon/i-icon.svg';
import callIcon from './images/call-icon/call-icon.svg';
import iIcon3x from './images/i-icon/i-icon@3x.svg';
import iIcon2x from './images/i-icon/i-icon@2x.svg';
import callIcon2x from './images/call-icon/call-icon@2x.svg';
import callIcon3x from './images/call-icon/call-icon@3x.svg';
const DeniedMessageBox = (props) => {
  const {text, subText, asBtn, tel} = props;

  var iIcons=[iIcon,iIcon2x,iIcon3x];
  var callIcons=[callIcon,callIcon2x,callIcon3x];

  const getBestImage = (icons) => {
  const dpr = window.devicePixelRatio || 1;
      if (dpr >= 3) return icons[2].bg();
      if (dpr >= 2) return icons[1].bg();
      return icons[0].bg();
  }

  return (
    <div className='denied-message-container'>
        <p className='message-text mb-0' style={{backgroundImage:getBestImage(iIcon)}}>
        <span className='d-block' dangerouslySetInnerHTML={{__html: text}} />
        {!asBtn && <span className='sub-text'>{subText}</span>}
      </p>

      {asBtn && (
        <div className={` ${asBtn ? 'asBtn text-center' : ''} sub-text`} style={{backgroundImage:getBestImage(callIcons)}} onClick={() => props.onclick()}>
          <a href={`tel:${tel || Config.businessCallNumber}`}>{subText}</a>
        </div>
      )}
    </div>
  );
};

export default DeniedMessageBox;
